import { Icon } from '@dayon/design-system';

/**
 * ONE PILL OF THE ACTION-QUEUE BAND: a queue's count, a second figure beside it, and its age.
 *
 * A BUTTON WHEN IT OPENS SOMETHING, AND NOT A CONTROL AT ALL WHEN IT DOES NOT. A pill whose
 * queue lives on a screen this reader cannot open is drawn as the same figures with no button
 * behind them — nothing to press, nothing to tab to, no lift on hover — and `note` says why,
 * naming the key. A button that does nothing, or one that opens a refusal, tells the reader there
 * is somewhere to go when there is not.
 */
export function QueuePill({
  icon,
  label,
  count,
  aside,
  meta,
  attention = false,
  onClick,
  note,
}: {
  icon: string;
  label: string;
  count: number;
  aside?: string | undefined;
  meta: string;
  attention?: boolean | undefined;
  /** Absent: the pill opens nothing for this reader, and `note` says why. */
  onClick?: (() => void) | undefined;
  /** Shown under the meta line on a pill that opens nothing. */
  note?: string | undefined;
}) {
  const body = (
    <>
      <span className="queue-pill-label">
        <Icon name={icon} style={attention ? { color: 'var(--portal-accent)' } : undefined} />
        {label}
      </span>
      <span className="queue-pill-value">
        <span className="tabular">{count}</span>
        {aside && (
          <span className="text-subtle" style={{ fontSize: '12px' }}>
            {aside}
          </span>
        )}
      </span>
      <span className="queue-pill-meta">{meta}</span>
    </>
  );
  const tone = attention ? 'queue-pill attention' : 'queue-pill';

  if (!onClick) {
    return (
      <div className={`${tone} static`}>
        {body}
        {note && <span className="queue-pill-note">{note}</span>}
      </div>
    );
  }
  return (
    <button type="button" className={tone} onClick={onClick}>
      {body}
    </button>
  );
}
